import { getFirstObject } from '../../../../global/common/convert';
import { realTimeScoring } from '../../dbActions/realtimeScoring';
import { matchCalcs } from '../../helpers/match';
import { ammendTeamName } from './SportsMatchReducer';
import { seasonalUpdateTypes } from './reducerHelpers/seasonalDataHelpers';
import { _matchResultSourceTypes } from 'projectSpecific/sports/useHelpers/useMatchResults';
import _ from 'lodash';

const rts = {
  handleSet_latestSeason: 'handleSet_latestSeason',
  handleShow_rtMatch: 'handleShow_rtMatch',
  handleSet_rtMatch: 'handleSet_rtMatch',
  handleRtChange_set: 'handleRtChange_set',

  handleCallback_delete: 'handleCallback_delete'
}

export const sportsRtMatchReducer = (state, action) => {

  const {
    gameScoringType,
    match_rt,
  } = state

  const { type } = action

  const _match_rt = { ...match_rt }


  switch (type) {

    case rts.handleSet_rtMatch:
      const { match_true: mt } = action
      const _mt = _.cloneDeep(mt)
      const { home, away } = _mt ?? {}
      if (action.match_rt) {
        const { item } = getFirstObject(action.match_rt)
        const { displayName, _results, tracker } = item ?? {}
        const rt_match = { home, away, _results }
        matchCalcs.calcVballMatch(rt_match, gameScoringType)
        return { ...state, match_true: mt, match_key: mt._itemKey, match_rt: rt_match, match_rt_tracker: initPointsTracker(_results, tracker), match_rt_name: displayName }
      } else {
        const rt_match = {
          home,
          away,
          _results: {
            setNumber: 1,
            score: {},
            scores: { 1: { home: 0, away: 0 } }
          }
        }
        matchCalcs.calcVballMatch(rt_match, gameScoringType)
        return { ...state, match_true: mt, match_key: mt._itemKey, match_rt: rt_match, match_rt_tracker: initPointsTracker() }
      }

    case rts.handleShow_rtMatch:
      if (action.match_rt) {
        return { ...state, showRealtimeScoringSelected: !state.showRealtimeScoringSelected, match_rt_selected: action.match_rt }
      } else {
        return { ...state, showRealtimeScoring: !state.showRealtimeScoring }
      }

    case rts.handleRtChange_set:
      // changes the set and creates a blank new set
      if (_match_rt) {
        _match_rt._results.setNumber = action.setNumber
        if (!_match_rt._results.scores[_match_rt.setNumber]) {
          _match_rt._results.scores[_match_rt._results.setNumber] = createNewSet()
        }
      }
      return { ...state, match_rt: _match_rt }


    case rts.handleCallback_delete:
      return { ...state, match_true: null, match_rt: null }

    case rts.handleSet_latestSeason:
      return { ...state, latestSeason: action.latestSeason }

    default:
      return { ...state }
  }
}

export const sportsRtMatchHandlers = (dispatch) => {
  return {
    handleCallback_delete: (e) => { dispatch({ type: rts.handleCallback_delete, e }) },
    handleRtChange_set: (setNumber) => { dispatch({ type: rts.handleRtChange_set, dispatch, setNumber }) },
    // handleRtUpdate_score: (match_rt, rtType, add, currentSetNumber, selectedStat) => { dispatch({ dispatch, type: rts.handleRtUpdate_score, match_rt, rtType, add, currentSetNumber, selectedStat }) },
    handleSet_latestSeason: (latestSeason) => { dispatch({ type: rts.handleSet_latestSeason, latestSeason }) },
    handleSet_rtMatch: (match_true, match_rt) => { dispatch({ type: rts.handleSet_rtMatch, match_true, match_rt }) },
    handleShow_rtMatch: (match_rt) => { dispatch({ type: rts.handleShow_rtMatch, match_rt }) },
  }
}

export const sportsRtMatchInitialState = (init_state) => {
  return { ...init_state }
};


export const matchNeedsUpdated = (matchResults, _results) => {
  if (matchResults && matchResults.score && _results.score)
    if (matchResults.score.home !== _results.score.home || matchResults.score.away !== _results.score.away) {
      return true
    }
}

export const fixTeamNames = (matches) => {
  Object.keys(matches).forEach(mk => {
    const match = matches[mk]
    const { home, away } = match ?? {}
    match.home = ammendTeamName(home)
    match.away = ammendTeamName(away)
  })
}

const createNewSet = () => {
  return {
    home: 0,
    away: 0
  }
}

const createTeam = (team) => {
  return {
    id: team._itemKey,
    levels: team.levels,
    sections: team.sections,
    name: team.name
  }
}

const initPointsTracker = (_results, tracker) => {

  const { setNumber, score } = _results ?? {}

  const _rt_tracker = tracker ? tracker : {
    setNumber: setNumber ? setNumber : 1,
    score: score ? { ...score } : { home: 0, away: 0 },
    pointHistory: [],
    streaks: { home: 0, away: 0 },
    largestDifference: { home: 0, away: 0 },
    setResults: []
  }

  return _rt_tracker
}


